import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Paper from "@mui/material/Paper";
import { Stack, Button } from "@mui/material";
import AddFeesDialog from "./AddFeesDialog";
import SnackbarComponent from "../Common/SnackbarComponent";
import EditStudent from "./EditStudent";
import Loader from "../Common/Loader";
import api from "../Auth/Middleware";

export default function StudentTable(props) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [snackbarMsg, setSnackbarMSg] = useState("");
  const [snackbarSevierty, setSnackbarSevierty] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [studentData, setStudentData] = useState(null);

  const columnDefs = [
    { headerName: "Name", field: "name", sortable: true, filter: true },
    { headerName: "Date of Birth", field: "dob", sortable: true, filter: true },
    { headerName: "Class", field: "class", sortable: true, filter: true },
    { headerName: "Father's Name", field: "fathername", sortable: true, filter: true },
    { headerName: "Contact", field: "contact", sortable: false, filter: true },
    {
      headerName: "Actions",
      cellRenderer: (params) => {
        return (
          <Stack direction="row" spacing={2}>
            <Button
              onClick={() => {               
                handleEdit(params.data.id);
              }}
              variant="outlined"
              color="primary"
            >
              Edit
            </Button>
            <Button
              onClick={() => {   
                handleAddFeesClick(params.data.id);
              }}
              variant="outlined"
              color="secondary"
            >
              Add Fees
            </Button>
          </Stack>
        );
      },
    },
    {
      headerName: "Fees Status", field: "pendingAmount", sortable: true, filter: true,
      cellStyle: (params) => {
        const value = params.value;
        if (value === "Please add fees") {
          return { color: "purple", fontWeight: "bold" };
        }
        if (value === "0") {
          return { color: "green", fontWeight: "bold" };
        }
        else{
          return { color: "red", fontWeight: "bold" };
        }
      }
    }  
  ];

  useEffect(() => {
    const fetchAllFeesData = async () => {
      try {
        const transformedArray = props?.data.map((obj) => ({
          id: obj.id,
          name: obj.firstName + " " + obj.lastName,
          dob: new Date(obj.dateOfBirth).toLocaleDateString("en-GB"),
          class: `${obj.class}th`,
          fathername: obj.fatherName,
          contact: obj.parentContact,
          pendingAmount: null, // Placeholder for pending fees
        }));
  
        // Fetch fees for each student
        const updatedData = await Promise.all(
          transformedArray.map(async (student) => {
            try {
              const response = await api.get(`Student/Fees/${student.id}`);
              const feesData = response.data;
              if (feesData?.length > 0) {
                const totalFees = feesData[0]?.total || 0;
                const paidSum = feesData.reduce(
                  (acc, fee) => acc + fee.amoutPaid,
                  0
                );
                const pendingAmount = totalFees - paidSum;

                return { ...student, pendingAmount: totalFees === 0 ? "Please add fees" : `${pendingAmount}` };
              } else {
                return { ...student, pendingAmount: "Please add fees"  };
              }
            } catch {
              return { ...student, totalFees: "Error", pendingAmount: "Error" };
            }
          })
        );
  
        setStudentData(updatedData);
      } catch (error) {
        console.error("Error fetching fees data:", error);
      }
    };
  
    fetchAllFeesData();
  }, [props.data]);  

  const handleAddFeesClick = (id) => {
    setEditDialogOpen(false);
    setDialogOpen(true);
    setSelectedRowId(id);
  };

  const handleEdit = (id) => {
    setDialogOpen(false);
    setEditDialogOpen(true);
    setSelectedRowId(id);
  };

  const handleCloseDialog = () => {
    setSelectedRowId(null);
    setDialogOpen(false);
  };

  const handleEditCloseDialog = () => {
    setSelectedRowId(null);
    setEditDialogOpen(false);
  };

  const openSuccessBar = () => {
    setSnackbarOpen(true);
    setSnackbarMSg("Fees added successfully!!");
    setSnackbarSevierty("success");
  };

  const openFailBar = () => {
    setSnackbarOpen(true);
    setSnackbarMSg("Couldn't save the changes, Please try again");
    setSnackbarSevierty("error");
  };

  const openEditSuccessBar = () => {
    setSnackbarOpen(true);
    setSnackbarMSg("Student Edited successfully!!");
    setSnackbarSevierty("success");
  };

  const closeSnackbar = () => {
    setSnackbarOpen(false);
  };

  const getStudentDataByID = (id) => {
    return props?.data.find((student) => student.id === id);
  };

  const selectedRow = studentData?.find((row) => row.id === selectedRowId);
  return (
    <>
      <SnackbarComponent
        open={snackbarOpen}
        severity={snackbarSevierty}
        message={snackbarMsg}
        onClose={closeSnackbar}
      />
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        {!studentData ? (
          <Loader />
        ) : (
          <div className="ag-theme-alpine" style={{ height: 440, width: "100%" }}>
            <AgGridReact
              columnDefs={columnDefs}
              rowData={studentData}
              pagination={true}
              paginationPageSize={20}
              defaultColDef={{
                resizable: true,
              }}
              animateRows={true}
            />
          </div>
        )}
      </Paper>
      {selectedRow && selectedRow.name && (
        <AddFeesDialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          onSuccess={openSuccessBar}
          onFail={openFailBar}
          studentDetail={selectedRow}
          id={selectedRowId}
        />
      )}
      {selectedRow && (
        <EditStudent
          openEdit={editDialogOpen}
          onEditClose={handleEditCloseDialog}
          onEditSuccess={openEditSuccessBar}
          onEditFail={openFailBar}
          studentDetail={getStudentDataByID(selectedRowId)}
          id={selectedRowId}
        />
      )}
    </>
  );
}
